import React, { useState, useEffect, Suspense } from "react";
import { connect } from "react-redux";
import { mainSelectors } from "stores/mainSlice";
import {
  Card,
  CardContent,
  Box,
  Container,
  Grid,
  Button,
  TextField,
} from "@mui/material";
import { DashboardMenu } from "components/Layout/DashboardMenu";
import { Outlet } from "react-router";

function PageWithMenuInner(props) {
  const { ContestoApp } = props;

  const [state, setState] = useState({
    loaded: true,
  });

  const [filterData, setFilterData] = useState("");

  useEffect(() => {
    //loadPageData();
  }, []);

  const onInputchange = (value) => {
    setFilterData(value);
  };

  const user = props.userSelector;
  const { loaded } = state;

  return (
    <div className="dashboard-wrapper">
      {loaded && (
        <>
          {
            <DashboardMenu
              user={user}
              ContestoApp={ContestoApp}
            ></DashboardMenu>
          }
          {/* {console.log("PageWithMenu - ContestoApp", ContestoApp)} */}
          <Suspense fallback={<div>Loading...</div>}>
            <Outlet />
          </Suspense>
        </>
      )}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    mainStore: state.main,
    userSelector: mainSelectors.userSelector(state),
  };
};

const mapDispatchToProps = {};

const PageWithMenu = connect(
  mapStateToProps,
  mapDispatchToProps
)(PageWithMenuInner);

export { PageWithMenu };
